import { render, staticRenderFns } from "./PostulantNewUser.vue?vue&type=template&id=451a21ce&scoped=true&"
import script from "./PostulantNewUser.vue?vue&type=script&lang=js&"
export * from "./PostulantNewUser.vue?vue&type=script&lang=js&"
import style0 from "./PostulantNewUser.vue?vue&type=style&index=0&id=451a21ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a21ce",
  null
  
)

export default component.exports